import { render, staticRenderFns } from "./EditarQuestionario.vue?vue&type=template&id=3af60314&scoped=true"
import script from "./EditarQuestionario.vue?vue&type=script&lang=js"
export * from "./EditarQuestionario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af60314",
  null
  
)

export default component.exports